import type { FeatureSetStatusForSeller } from '@squareup/shared-types-protos/squareup/featurama/feature_sets';
import type { FeatureStatusForSeller } from '@squareup/shared-types-protos/squareup/featurama/model';
import type { FeatureStatusMap, FeatureSetActivationStatusForSellerMap } from '../types/feature';

export const featureResponseToFeatureMap = (
  featureStatuses?: FeatureStatusForSeller[],
) => {
  const featuresMap = {} as FeatureStatusMap;
  for (const featureStatus of featureStatuses ?? []) {
    if (featureStatus.key === undefined) {
      continue;
    }

    featuresMap[featureStatus.key] = featureStatus;
  }
  return featuresMap;
};

export const featureSetResponseToFeatureSetMap = (
  featureSetStatuses?: FeatureSetStatusForSeller[],
) => {
  const featureSetMap = {} as FeatureSetActivationStatusForSellerMap;
  for (const featureSetStatus of featureSetStatuses ?? []) {
    // The following conditional exists to prevent Typescript errors when generating the mapping because
    // the proto definition allows for featureSetKey and activationStatus fields to be optional. However,
    // both fields should always be present in practice.
    if (featureSetStatus.featureSetKey === undefined || featureSetStatus.activationStatus === undefined) {
      continue;
    }

    featureSetMap[featureSetStatus.featureSetKey] = featureSetStatus.activationStatus;
  }
  return featureSetMap;
};
